import { render, staticRenderFns } from "./mydownloadtable.vue?vue&type=template&id=60f5e51c&scoped=true&"
import script from "./mydownloadtable.vue?vue&type=script&lang=js&"
export * from "./mydownloadtable.vue?vue&type=script&lang=js&"
import style0 from "./mydownloadtable.vue?vue&type=style&index=0&id=60f5e51c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5e51c",
  null
  
)

export default component.exports